export default {
  'imformative.list.header.date': 'Creation date',
  'imformative.list.header.creator': 'creator',
  'informative.list.header.message': 'Message',
  'informative.list.header.new.informative': 'New informative',
  'informative.list.header.actions': 'Actions',

  'informative.form.date': 'Date',
  'informative.form.employee': 'Employee',
  'informative.form.mensage': 'Mensage',
  'informative.form.userGroup': 'User Group',
  'informative.form.user': 'User',

  'informative.create.notification.success': 'Informative added!',
  'informative.create.notification.successDescription':
    'The Informative has been successfully added!',
  'informative.update.notification.success': 'Information changed!',
  'informative.update.notification.successDescription':
    'Information has been changed successfully!',
  'informative.notifications.remove.confirm.title':
    'Do you really want to delete this informative?',
  'informative.notifications.remove.confirm.content':
    'By removing the informative, all of their information will be permanently lost. Still want to continue?',
  'informative.notifications.remove.success.title':
    'Informative successfully removed!',
  'informative.notifications.remove.success.description':
    'The informative was successfully removed from the system.',
};
